import type { JSX } from 'react';
import AppShell from '../AppShell';
import { useLayoutContext } from '../../contexts/LayoutContext';
import { useSessionContext } from '../../contexts/SessionContext';
import { useI18n } from '../../i18n';
import { StudioSurface } from './StudioSurface';

/**
 * Переключатель стол ⇄ GM Studio. Живёт ПОД общим in-session провайдер-стеком
 * (App.tsx), поэтому Studio делит с AppShell тот же WS и контексты. Studio
 * доступна только GM; для игроков всегда рендерится стол.
 */
export function StudioGate(): JSX.Element {
  const { state, dispatch } = useLayoutContext();
  const { mp, isGM, pages } = useSessionContext();
  const { t } = useI18n();

  if (state.studioOpen && isGM) {
    return (
      <StudioSurface
        // The campaign's name as the lobby shows it (gmName), not the short code (owner 23.10).
        campaignLabel={mp.session?.gmName?.trim() || mp.session?.slug || mp.session?.code || ''}
        // GJ-29: a campaign made without a name carries its master's name (the lobby's default) — the header says «no name», not that.
        campaignUnnamed={(mp.session?.gmName?.trim() ?? '') !== '' && mp.session?.gmName?.trim() === mp.participant?.name?.trim()}
        sessionLabel={''}
        t={t}
        onExitStudio={(): void => {
          // Leaving Studio is a plain exit to the table on the players' map
          // (GM Studio 5.1) — a local view change, never an activation. The
          // Studio map panes do not touch the table's view (5.3), so the exit
          // says it itself. «Open at the table for yourself» leaves a preview
          // request just before; the table honours it once it is mounted.
          pages.returnToActive();
          dispatch({ type: 'layout:toggleStudio' });
        }}
      />
    );
  }
  return <AppShell />;
}

export default StudioGate;
